import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetProgramInstituteCoursesRequestObjectSchema,
  GetProgramInstituteCoursesRequestObjectType,
  GetProgramInstituteCoursesResponseSchema,
  GetProgramInstituteCoursesResponseType
} from '../../../services/NwProductsExtensionsServices/APIService/types';

import { useNwProductsExtensionsService } from '../useNwProductsExtensionsService';

interface UseGetProgramInstituteCoursesApiInterface {
  getProgramInstituteCourses: UseMutateAsyncFunction<
    GetProgramInstituteCoursesResponseType,
    Error,
    GetProgramInstituteCoursesRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetProgramInstituteCoursesApi =
  (): UseGetProgramInstituteCoursesApiInterface => {
  const { nwProductsExtensionsServiceInstance } =
    useNwProductsExtensionsService();

  const getProgramInstituteCourses = (
    requestObject: GetProgramInstituteCoursesRequestObjectType
  ) => {
    try {
      GetProgramInstituteCoursesRequestObjectSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return nwProductsExtensionsServiceInstance
      .getProgramInstituteCourses(requestObject)
      .then((response) => {
        try {
          GetProgramInstituteCoursesResponseSchema.parse(response ?? {});
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { mutateAsync, error, status } = useMutation(getProgramInstituteCourses, {
    mutationKey: ['getProgramInstituteCourses']
  });

  return {
    getProgramInstituteCourses: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useGetProgramInstituteCoursesApi };
